import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7936b628")

_pushScopeId("data-v-7936b628")
const _hoisted_1 = { class: "c-header c-header-light c-header-fixed c-header-with-subheader" }
const _hoisted_2 = /*#__PURE__*/_createVNode("button", {
  class: "c-header-toggler c-class-toggler d-lg-none mfe-auto",
  type: "button",
  "data-target": "#sidebar",
  "data-class": "c-sidebar-show"
}, [
  /*#__PURE__*/_createVNode("svg", { class: "c-icon c-icon-lg" }, [
    /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-menu" })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  class: "c-header-brand d-lg-none",
  href: "#"
}, [
  /*#__PURE__*/_createVNode("img", { src: "/img/logo.png" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("button", {
  class: "c-header-toggler c-class-toggler d-md-down-none",
  type: "button",
  "data-target": "#sidebar",
  "data-class": "c-sidebar-lg-show",
  responsive: "true"
}, [
  /*#__PURE__*/_createVNode("svg", { class: "c-icon c-icon-lg" }, [
    /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-menu" })
  ])
], -1)
const _hoisted_5 = { class: "breadcrumb border-0 m-0" }
const _hoisted_6 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "c-header-nav ml-auto mr-4" }
const _hoisted_10 = { class: "c-header-nav-item dropdown" }
const _hoisted_11 = /*#__PURE__*/_createVNode("a", {
  class: "c-header-nav-link",
  "data-toggle": "dropdown",
  href: "#",
  role: "button",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("div", { class: "c-avatar" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "c-avatar-img",
      src: "/img/avatars/user_icon.png",
      alt: "user@email.com"
    })
  ])
], -1)
const _hoisted_12 = { class: "dropdown-menu dropdown-menu-right pt-0" }
const _hoisted_13 = /*#__PURE__*/_createVNode("svg", { class: "c-icon mr-2" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-account-logout" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Logout ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("header", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode("ol", _hoisted_5, [
      (_ctx.$route.name !== 'Index')
        ? (_openBlock(), _createBlock("li", _hoisted_6, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("li", _hoisted_8, _toDisplayString(_ctx.$route.meta.text), 1)
    ]),
    _createVNode("ul", _hoisted_9, [
      _createVNode("li", _hoisted_10, [
        _hoisted_11,
        _createVNode("div", _hoisted_12, [
          _createVNode("a", {
            class: "dropdown-item",
            href: "javascript:void(0)",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, [
            _hoisted_13,
            _hoisted_14
          ])
        ])
      ])
    ])
  ]))
})